import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { useAuthStore } from "./auth.store";
import apiOrganizationClient from "../api/api.organization";
import { OrganizationStore } from "../types/Store/OrganizationStore.types";
import { enqueueSnackbar } from "notistack";
import { throwError } from "../hooks/useErrorHandler";

export const useOrganizationStore = create<OrganizationStore>()(
    persist(
        (set, get) => ({
            organization: null,
            posts: [],
            total_posts: 0,
            feedbacks: [],
            total_feedbacks: 0,
            service_organizations: [],

            getOrganizationInfo: async (organization_id) => {
                const { user, activeAccount} = useAuthStore.getState();
                if (user) {
                    const { data } = await apiOrganizationClient.get(
                        "/api/v1/organization/service-organizations/" +
                            organization_id + "?personal_account_id=" + activeAccount ,
                    );
                    set({ organization: data });
                    console.log(data);
                } else {
                    location.href = "/admin";
                }
            },

            sendFeedback: async (formData) => {
                const { activeAccount } = useAuthStore.getState();
                let success = false;
                if (formData.file) {
                    const fd = new FormData();
                    fd.append("file", formData.file);

                    const { data, status } = await apiOrganizationClient.post(
                        `/api/v1/feedback/feedback/photo?personal_account_id=${activeAccount}&reason=${formData.reason}&title=${formData.title}&description=${formData.description}`,
                        fd,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                            onUploadProgress: (e) => {
                                if (e.total) {
                                    const percent = Math.round(
                                        (e.loaded * 100) / e.total,
                                    );
                                    console.log(
                                        `Загружено feedback: ${percent}%`,
                                    );
                                }
                            },
                        },
                    );
                    success = status == 200;
                    console.log("data form answer", data);
                } else {
                    const { data, status } = await apiOrganizationClient.post(
                        "/api/v1/feedback/feedback",
                        {
                            personal_account_id: activeAccount,
                            reason: formData.reason,
                            title: formData.title,
                            description: formData.description,
                        },
                    );

                    console.log("data form answer", data);
                    success = status == 200;
                }

                if (success) {
                    enqueueSnackbar({
                        message: "Успешно отправлено заявление",
                        variant: "success",
                    });
                    // setTimeout(() => {
                    //     location.reload();
                    // }, 2000);
                }
            },

            getPosts: async (offset = 0) => {
                const { user, activeAccount } = useAuthStore.getState();
                if (user) {
                    const { data } = await apiOrganizationClient.get(
                        "/api/v1/organization/posts?organization_id=" +
                            user?.organization_id +
                            "&offset=" +
                            offset +
                            "&personal_account_id=" +
                            activeAccount,
                    );

                    set({ posts: data.posts, total_posts: data.total_count });
                }
            },

            getFeedbacks: async (offset = 0, order = "DESC") => {
                const { activeAccount } = useAuthStore.getState();
                const { data } = await apiOrganizationClient.get(
                    "/api/v1/feedback/feedback?offset=" +
                        offset * 10 +
                        "&personal_account_id=" +
                        activeAccount + "&sort_order=" + order,
                );
                set({
                    feedbacks: data.feedbacks,
                    total_feedbacks: data.total_count,
                });
            },

            getFeedbackByID: async (id: String) => {
                try {
                    const { data } = await apiOrganizationClient.get(
                        "/api/v1/feedback/feedback/" + id,
                    );
                    return data;
                } catch (error) {
                    throwError(error);
                    return null;
                }
            },

            async getServiceOrganizations() {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data } = await apiOrganizationClient.get(
                        "/api/v1/organization/service-organizations?personal_account_id=" +
                            activeAccount,
                    );
                    return data.service_organizations
                } catch (error) {
                    throwError(error);
                    return null
                }
            },

            async getDocumentsByOrganization(id, page = 1, order = "DESC") {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data } = await apiOrganizationClient.get(
                        "/api/v1/organization/service-organizations/documents?personal_account_id=" +
                            activeAccount
                            + "&service_organization_id=" + id.toString()
                            + "&offset=" + (page - 1) * 10 + "&sort_order=" + order,
                    );
                    return [data.documents, data.total_count];
                } catch (error) {
                    throwError(error);
                    return null;
                }
            },
        }),
        {
            name: "organization-store", // ключ в localStorage
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                organization: state.organization,
            }),
        },
    ),
);
